import './App.css';

function PlayingNow(props) {



  function convertToDateTime(timeStr, date) {
    console.log("TIme String"+timeStr);
    console.log("Date of selected show" + date);
    if (timeStr.length !== 6) {
        throw new Error("Invalid time format. Expected HHMMSS.");
    }

    // Extract hours, minutes, and seconds from the string

    let year = parseInt(date.substring(0, 4), 10);
    let month = parseInt(date.substring(4, 6), 10);
    let day = parseInt(date.substring(6, 8), 10);
    console.log("YEAR "  + year + "month " + month + "day " + day);

    let hours = parseInt(timeStr.substring(0, 2), 10);
    let minutes = parseInt(timeStr.substring(2, 4), 10);
    let seconds = parseInt(timeStr.substring(4, 6), 10);


    // Create a new date with the current date and the provided time
    let dateTime = new Date(year, month-1 , day, hours, minutes, seconds);
    //console.log("JS Date time : " + dateTime.getTime())
    return dateTime;
  }
 
  function getEndTime(startTime, duration){

    console.log("StarTime"+startTime);
    console.log("duration: "+ duration);
    var newDate= new Date((startTime.getTime() + (duration*1000)));
    
    return newDate;
  
  }
  if(props.show!=null){
    let formatedStartTime = (convertToDateTime(props.show.start_time, props.show.date));
      
      
    let options = { hour: '2-digit', minute: '2-digit', hour12: true };
    let timeString = formatedStartTime.toLocaleTimeString('en-US', options);
    let trimmedDescription = (props.show.description)
    
    let epTitle = props.show.title;
    let formatedEndTime = getEndTime(formatedStartTime, props.show.duration);
    console.log("end time : "+ formatedEndTime);


    console.log("props.blackoutData");
    
    let newArray = props.blackoutData;
    //console.log(newArray);
    let live = <a href="https://www.parrot.tv/?utm_source=CHCHCOM&utm_medium=Video&utm_campaign=CHCH_Player_Parrot&utm_id=CHCHCOM_Live_Stream&utm_content=Top_Bar#!/hero/parrot-chch
" target="_blank" id="watchLivePlaynowButtonLink"><button className="watchNowButton" >Watch Live</button></a>;

    newArray.forEach((ele, index) => {
      let blackoutStart = new Date(ele['start']);
      let blackoutEnd = new Date(ele['end']);
      if(ele['countries'].length<=0){

        if(  blackoutStart <= formatedStartTime && formatedStartTime < blackoutEnd ){
          live = false;
          console.log(index);
          console.log("blackoutStart: "+ blackoutStart +"Shwo Start" +formatedStartTime);
          console.log("blackoutEnd: "+blackoutEnd + "Shwo END" +formatedEndTime);
        }
        console.log(index);
        console.log("blackoutStart: "+ blackoutStart +"Shwo Start" +formatedStartTime);
        console.log("blackoutEnd: "+blackoutEnd + "Shwo END" +formatedEndTime);
      }
    });
    return(
      <div id="playingNowContainer">
      
      <h2>Playing Now</h2>
    
      <div className="playingNowContainer" onClick={ () => props.showSection("playingNow")}>
        <div className="showWide">
          
          <div className="showColImage">
              <img className="showImage" src={props.show.thumbnail_path} />
          </div>
    
          <div className="showCol playingNowText" id="textPLayingNowFirst">  
              <h5>{timeString}</h5>
              <h4>{epTitle}</h4>
              <p>{trimmedDescription}</p>
              {live}
              
          </div>
          
          </div>
        </div>
        </div>)
  }else{
    return(<></>);
  }
/*
  if(props.show.thumbnail_path === undefined || props.show.description === undefined){
    return(<></>);
  }
*/
 

 
}

export default PlayingNow;
